import API from '../api';

export const tradingHistoryWT = (params) => API.post('/api/v1/trading-history/orders', params);

export const getTradingHistorySymbols = (logins?: string[]) =>
  API.post('/api/v1/trading-history/symbols', { logins });
